export enum STEP {
  VERIFICATION = 'verification',
  JOINING_ORG = 'joining-organization',
  ORG_CONFIRMATION = 'organization-confirmation',
  SEVERAL_ORG_MATCH = 'several-matching-organizations',
}
